module.exports = __webpack_public_path__ + "static/media/Haley-Powers.17a03a4e.png";